import useLocalApplications from './useLocalApplications';

export default useLocalApplications;
